import { EligibilitySupportDisabledIndividualScreen } from "@/interactors/EligibilitySupportDisabledIndividualScreen";

export default function SupportDisabledIndividual() {
  return <EligibilitySupportDisabledIndividualScreen />;
}
